<template>
  <div class="sport" :class="'matches-list-group-' + group" :style="{ height: sport.height + 'px', top: sport.top + 'px' }">
    <div class="sport-hat" style="margin-top: -4px !important; margin-right: 10px;">
      <div class="sport-info">
        <sport-icon-liga-white class="sport-icon-liga-white" :name="sport.alias" />
        <div class="sport-name" :title="sport.name">{{ sport.name }}</div>
        <!--sport-group-switcher
          class="group-switcher"
          :quantity="2"
          :group="group"
          @change="switchGroup" /-->
      </div>
      <div class="factor-names-1 factor-names">
        <div class="factor-cell" v-for="(h, i) in sport.head[0]" :key="i">{{ h.name }}</div>
      </div>
      <!--div class="factor-names-2 factor-names">
        <div class="factor-cell" v-for="(h, i) in sport.head[1]" :key="i">{{ h.name }}</div>
      </div-->
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite.vue'
import SportGroupSwitcher from '@/components/SportGroupSwitcher'

export default {
  components: { SportIconLigaWhite, SportGroupSwitcher },
  props: {
    sport: Object,
    type: {
      validator: function (value) {
        return [ 'prematch', 'live' ].indexOf(value) !== -1
      }
    },
    group: Number
  },
  methods: {
    switchGroup (group) {
      this.$store.commit(`${this.type}/SET_OVERVIEW_GROUP`, {
        sport: this.sport.id,
        group: group
      })
    }
  }
}
</script>

<style scoped>
.sport { position: absolute; width: 100%; }
.sport-hat { display: flex; }
.sport-info { display: flex; flex: 0 0 32%; max-width: 32%; }
.sport-icon-liga-white { margin: 14px 3px 12px 5px; }
.sport-name { flex: 1 1; font-size: 18px; line-height: 50px; overflow: hidden; padding-right: 10px; text-overflow: ellipsis; white-space: nowrap; }
.group-switcher { flex: 0 0; margin-right: 2px; }
.factor-names { display: none; flex: 1 1; }
.factor-cell { align-self: center; flex-grow: 1; margin-left: 1px; text-align: center; }
</style>

<style>
.matches-list-group-1 .factor-names-1,
.matches-list-group-2 .factor-names-2,
.matches-list-group-1 .event .factors-1,
.matches-list-group-2 .event .factors-2 { display: flex; }
</style>



// WEBPACK FOOTER //
// src/components/sports/matches/Sport.vue